import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { isPortalAdminUser } from "../utils/portalAccess";

const RedirectHome = () => {
  const acp = secureLocalStorage.getItem("acp");
  const company = secureLocalStorage.getItem("ab");
  const isAdminPortal = isPortalAdminUser(acp, company);

  return (
    <Navigate
      to={isAdminPortal ? "assignment" : "task"}
      replace
    />
  );
};

export default RedirectHome;